import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationStateHelperService {

  public returnUrl: string = "/";
  public unauthorizedToken: boolean = false;
  /** When LoginComponent last sent a refused, still-signed-in user home, so a refusal of home itself can't loop. */
  public sentHomeAfterRefusalAt: number = 0;
  
  constructor() { }
}
